import React, { Component } from "react";
import Global from "../../../../Global";
import "./PopularServices.css";
import PopularServicesItemList from "./PopularServicesItemList";
import SectionLabel from "../../../common/SectionLabel";

class PopularServices extends Component {
  constructor(props) {
    super(props);

    this.state = {
      popularServices: [],
    };
  }

  componentWillMount() {
    var url = Global.getAPI("home-popular-services");
    var self = this;
    fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: home-popular-services");
        }
        return response.json();
      })
      .then(function(data) {
        self.setState({
          popularServices: data.popularServices,
        });
      });
  }

  render() {
    const { popularServices } = this.state;

    const lang = window.THREE_REACT_APP_GLOBAL.language;
    const sectionLabel = lang === "tc" ? "熱門服務" : "Popular Services";

    return (
      <div className="container-popular-services">
        <SectionLabel text={sectionLabel} />
        <PopularServicesItemList services={popularServices} />
      </div>
    );
  }
}

export default PopularServices;
